export class JobProgressStepDatabaseConfigurationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceClass",
            "baseName": "instanceClass",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceCount",
            "baseName": "instanceCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "storageType",
            "baseName": "storageType",
            "type": "string",
            "format": ""
        },
        {
            "name": "allocatedStorageGib",
            "baseName": "allocatedStorageGib",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepDatabaseConfigurationData.attributeTypeMap;
    }
    constructor() {
    }
}
